import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getChat } from '../../../services/chats';
import { IChat } from '../../../services/chats/types';

interface IProps {
  chatId: number;
}
export const ThunkGetChat = createAsyncThunk<IChat, IProps>(
  `${storeResources.CHATS}/getChat`,
  ({ chatId }) => getChat(chatId).then(res => res.data),
);
